import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { useState } from "react";

interface ConfirmDeleteDialogProps {
  itemName: string;
  itemType: string;
  onConfirm: () => void;
  triggerVariant?: "ghost" | "destructive" | "outline";
  triggerSize?: "sm" | "icon";
  triggerClassName?: string;
  disabled?: boolean;
}

export function ConfirmDeleteDialog({
  itemName,
  itemType,
  onConfirm,
  triggerVariant = "ghost",
  triggerSize = "icon",
  triggerClassName,
  disabled,
}: ConfirmDeleteDialogProps) {
  const [open, setOpen] = useState(false);

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <Button
          variant={triggerVariant}
          size={triggerSize}
          disabled={disabled}
          className={triggerClassName}
          title={`Excluir ${itemType}`}
        >
          <Trash2 className="w-3.5 h-3.5" />
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Excluir {itemType}?</AlertDialogTitle>
          <AlertDialogDescription>
            Esta ação não pode ser desfeita. {itemType.charAt(0).toUpperCase() + itemType.slice(1)}{" "}
            <strong>{itemName}</strong> será removido(a) permanentemente.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Excluir
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
